import React, { useCallback } from 'react';

import { Text, View } from 'react-native';

import { useTranslation } from 'react-i18next';
import FastImage from 'react-native-fast-image';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useDispatch, useSelector } from 'react-redux';

import { placeHolderDetailLandscape } from 'assets/images';

import { selectLayoutConfig } from 'store/config/selectors';
import { setSpotlightVideoVisible } from 'store/player/actions';

import useAnimatedHeader from 'utils/hooks/useAnimatedHeader';
import useHeaderConfig from 'utils/hooks/useHeaderConfig';
import { isTabletOrWeb, isWeb } from 'utils/responsiveness';

import DetailImageGradient from 'screens/Detail/components/DetailImageGradient';
import {
    NON_INTERACTIVE_UI_PROMOTION_PAGE_DESCRIPTION,
    NON_INTERACTIVE_UI_PROMOTION_PAGE_SUB_TITLE,
    NON_INTERACTIVE_UI_PROMOTION_PAGE_TITLE,
    WATCH_THE_PROMO_BUTTON,
} from 'screens/Promotional/constants';
import styles from 'screens/Promotional/styles';

import BaseTileImage from 'components/BaseTileImage';
import ActionButton from 'components/CustomButtons/ActionButton';
import {
    AspectRatio,
    ImageContentType,
    ImageSize,
    ImageType,
} from 'components/NagraImage/types';
import SimpleNavigationHeaderRight from 'components/NavigationHeader/SimpleNavigationHeader/Right';
import {
    PLACEHOLDER_ICON_CENTER,
    PLACEHOLDER_ICON_RIGHT,
} from 'components/Ribbon/constants';

function Promotional() {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { pageScrollPosition } = useAnimatedHeader();

    const { primary } = useSelector(selectLayoutConfig);

    useHeaderConfig({
        headerTransparent: true,
        pageScrollPosition,
        headerRight: () => <SimpleNavigationHeaderRight needsClose={false} />,
        isRoot: isWeb,
        noInsetHeader: true,
    });

    const handleWatchPress = useCallback(() => {
        dispatch(setSpotlightVideoVisible(true));
    }, []);

    return (
        <SafeAreaView>
            <View style={styles.contentContainer}>
                <Text
                    style={styles.title}
                    numberOfLines={3}
                    {...(isWeb && { tabIndex: 0 })}
                >
                    {t(NON_INTERACTIVE_UI_PROMOTION_PAGE_TITLE)}
                </Text>
                <Text style={styles.subtitle} {...(isWeb && { tabIndex: 0 })}>
                    {t(NON_INTERACTIVE_UI_PROMOTION_PAGE_SUB_TITLE)}
                </Text>
                <Text
                    style={styles.description}
                    {...(isWeb && { tabIndex: 0 })}
                >
                    {t(NON_INTERACTIVE_UI_PROMOTION_PAGE_DESCRIPTION)}
                </Text>
                <View style={styles.buttonContainer}>
                    <ActionButton
                        title={WATCH_THE_PROMO_BUTTON}
                        onPress={handleWatchPress}
                        fillColor={primary}
                        buttonTextStyle={styles.buttonText}
                        accessibilityLabel={t(WATCH_THE_PROMO_BUTTON)}
                        accessible
                    />
                </View>
            </View>
            <View style={styles.root}>
                <BaseTileImage
                    style={styles.image}
                    contentId="promo_1"
                    contentType={ImageContentType.PROMO}
                    imageType={ImageType.BACKGROUND}
                    aspect={AspectRatio.LANDSCAPE}
                    width={ImageSize.BACKGROUND.width}
                    resizeMode={FastImage.resizeMode.cover}
                    placeHolder={
                        isTabletOrWeb
                            ? PLACEHOLDER_ICON_RIGHT
                            : PLACEHOLDER_ICON_CENTER
                    }
                    backupSource={isWeb && placeHolderDetailLandscape}
                />
                <DetailImageGradient />
            </View>
        </SafeAreaView>
    );
}

export default Promotional;
